module.exports = __webpack_public_path__ + "images/ninja-bc9adace59ba96c8da3af04b33c2f689.png";